import { component } from 'picoapp'
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export default component((node, ctx) => {
    const sliderElem = node.querySelector('[data-slider]');
    const swiper = new Swiper(sliderElem, {
        slidesPerView: 1,
        spaceBetween: 5,
        centerInsufficientSlides: true,
        breakpoints: {
            // when window width is >= 320px
            740: {
              slidesPerView: 2,
            },
            // when window width is >= 480px
            1200: {
              slidesPerView: 3,
            },
            // when window width is >= 640px
            1840: {
              slidesPerView: 4,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })
})